import * as Yup from 'yup'
import { getNewPasswordSchema } from '../../../../../../util/auth.util'

export const FORM_FIELDS = {
  IS_AUTO_GENERATING_PASSWORD: 'isAutoGeneratingPassword',
  NEW_PASSWORD: 'newPassword',
  CHANGE_PASSWORD_AT_NEXT_LOGIN: 'changePasswordAtNextLogin',
  SEND_PASSWORD_ON_COMPLETION: 'sendPasswordOnCompletion',
  IS_SENDING_PASSWORD_TO_ME: 'isSendingPasswordToMe',
  CURRENT_USER_EMAIL: 'currentUserEmail',
  SEND_PASSWORD_TO_EMPLOYEE_EMAIL: 'sendToEmployeeEmail',
}

export const INITIAL_VALUES = {
  [FORM_FIELDS.CHANGE_PASSWORD_AT_NEXT_LOGIN]: true,
  [FORM_FIELDS.IS_AUTO_GENERATING_PASSWORD]: true,
  [FORM_FIELDS.NEW_PASSWORD]: '',
  [FORM_FIELDS.SEND_PASSWORD_ON_COMPLETION]: true,
  [FORM_FIELDS.IS_SENDING_PASSWORD_TO_ME]: true,
  [FORM_FIELDS.CURRENT_USER_EMAIL]: '',
  [FORM_FIELDS.SEND_PASSWORD_TO_EMPLOYEE_EMAIL]: null,
}

export const FIELDS_TO_VALIDATE = {
  [FORM_FIELDS.CHANGE_PASSWORD_AT_NEXT_LOGIN]: true,
  [FORM_FIELDS.IS_AUTO_GENERATING_PASSWORD]: true,
  [FORM_FIELDS.NEW_PASSWORD]: true,
  [FORM_FIELDS.SEND_PASSWORD_ON_COMPLETION]: true,
  [FORM_FIELDS.IS_SENDING_PASSWORD_TO_ME]: true,
  [FORM_FIELDS.CURRENT_USER_EMAIL]: true,
  [FORM_FIELDS.SEND_PASSWORD_TO_EMPLOYEE_EMAIL]: true,
}

export const buildInitialValues = ({ currentUserEmail, autoGeneratedPassword }) => ({
  ...INITIAL_VALUES,
  [FORM_FIELDS.NEW_PASSWORD]: INITIAL_VALUES[FORM_FIELDS.IS_AUTO_GENERATING_PASSWORD] ? autoGeneratedPassword : '',
  [FORM_FIELDS.CURRENT_USER_EMAIL]: currentUserEmail,
})

export const getValidationSchema = (intl) => {
  const requiredMessage = intl.formatMessage({ id: 'AUTH.VALIDATION.REQUIRED_FIELD' })

  return Yup.object().shape({
    [FORM_FIELDS.CHANGE_PASSWORD_AT_NEXT_LOGIN]: Yup.boolean(),
    [FORM_FIELDS.IS_AUTO_GENERATING_PASSWORD]: Yup.boolean(),
    [FORM_FIELDS.NEW_PASSWORD]: Yup.string().when(FORM_FIELDS.IS_AUTO_GENERATING_PASSWORD, {
      is: false,
      then: () => getNewPasswordSchema(intl),
    }),
    [FORM_FIELDS.SEND_PASSWORD_ON_COMPLETION]: Yup.boolean(),
    [FORM_FIELDS.IS_SENDING_PASSWORD_TO_ME]: Yup.boolean(),
    [FORM_FIELDS.CURRENT_USER_EMAIL]: Yup.string(),
    [FORM_FIELDS.SEND_PASSWORD_TO_EMPLOYEE_EMAIL]: Yup.string()
      .nullable()
      .when(FORM_FIELDS.IS_SENDING_PASSWORD_TO_ME, {
        is: false,
        then: () => Yup.string().required(requiredMessage),
      }),
  })
}

export const toApiPayload = (values) => {
  let sendPasswordTo = []
  if (values[FORM_FIELDS.SEND_PASSWORD_ON_COMPLETION]) {
    sendPasswordTo = [
      values[FORM_FIELDS.IS_SENDING_PASSWORD_TO_ME]
        ? values[FORM_FIELDS.CURRENT_USER_EMAIL]
        : values[FORM_FIELDS.SEND_PASSWORD_TO_EMPLOYEE_EMAIL],
    ]
  }

  return {
    passwordInfo: {
      changePasswordAtNextLogin: values[FORM_FIELDS.CHANGE_PASSWORD_AT_NEXT_LOGIN],
      sendPasswordTo,
      newPassword: values[FORM_FIELDS.NEW_PASSWORD] || null,
    },
  }
}
